import React from "react"
import { Text } from "@chakra-ui/react"
import { useRouteLoaderData } from "react-router-dom"
import env from "../lib/env"
import GradientBox from "@/components/GradientBox"
import Message from "@/components/Message"
import AccountLayout from "@/components/AccountLayout"

const publishableKey =
  process.env.BLINDINSIGHT_STRIPE_PUBLISHABLE_KEY ||
  env.BLINDINSIGHT_STRIPE_PUBLISHABLE_KEY
const pricingTableId =
  process.env.BLINDINSIGHT_STRIPE_PRICING_TABLE_ID ||
  env.BLINDINSIGHT_STRIPE_PRICING_TABLE_ID

export default function ChoosePlanView() {
  const user = useRouteLoaderData("auth")

  const gradientBox = (
    <GradientBox>
      <Text fontSize="2em" color="white">
        Please choose a plan
      </Text>
      <span />
      <span />
      <span />
    </GradientBox>
  )

  const message = (
    <Message>
      <stripe-pricing-table
        width="100%"
        style={{ flex: 1, width: "100%", minHeight: "80vh" }}
        pricing-table-id={pricingTableId}
        publishable-key={publishableKey}
        customer-email={user.email}
        client-reference-id={user.id}
      />
    </Message>
  )

  return <AccountLayout gradientBox={gradientBox} message={message} />
}
